import {
  Injectable
} from '@angular/core';
import {
  Observable,
  Subscriber,
  Subject
} from 'rxjs';
import {
  Station,
  StationDetail,
  StationAvailabilities,
  Availabilitie,
  StationPrice,
  StationDetailGuest
} from '../models/api_models/station';
import {
  HttpHeaders,
  HttpClient
} from '@angular/common/http';
import {
  AutorizationService
} from './autorization.service';
import {
  Token
} from '../models/api_models/token';
import {
  BasicResponse
} from '../models/api_models/basicResponse';
import {
  PublicService
} from './public.service';

import {
  UserApiService
} from '../user-api.service';
import {  CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class StationService {



  publicUrl = "https://api1.clem.mobi/";




  public convertStationDetailToStation(detail: StationDetail): Station {
    if (detail === null) {
      return null;
    }
    let station: Station = new Station(detail.autonomy, detail.available, detail.car_name, detail.guest_booking, detail.id, 0, 0, detail.name, detail.type, detail.info_specific);
    return station;
  }

  private checkData(data) {
    // // // console.log(data);
    return false;
  }

  public getStationPriceTextGuest(stationId : number) {
  
    return new Observable < StationDetailGuest> ((observer) => {
      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;
        if (token == null) {
          observer.error(null);
          observer.complete();
        }
          var header = {
            headers: new HttpHeaders()
              .set('Authorization', 'Bearer ' + token.access_token)
              .set('Content-Type', 'application/x-www-form-urlencoded')
          }
          var currentDate = new Date();
          if (currentDate.getMinutes() >= 30) {
            currentDate.setMinutes(30,0,0);
          }
          else {
            currentDate.setMinutes(0,0,0);
          }
          this.http.get(this.publicUrl + "/api/v2/guest/station_details/"+ stationId +"/price?duration=2&startdate="+ currentDate.toISOString() +"&language=FR", header).subscribe(
            response => {
      
              observer.next( <StationDetailGuest > ( < BasicResponse > response).data);
              observer.complete();
      
            }, error => {
              observer.error(null)
              observer.complete()
            });

      }, error => {
        observer.error(null);
        observer.complete();
      }
        )
      });
  }

  public getStationAvailabilitiesAuth(station: Station, departure: string, arrival: string, sd: any, ed: any, checkAround: boolean = true, observer: Subscriber < StationAvailabilities[] > , token: Token) 
  {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
        .set('Content-Type', 'application/x-www-form-urlencoded')
    }
    this.http.get(this.publicUrl + "api/v2/stations/" + station.id + "/availabilities?startdate=" + departure + "&enddate=" + arrival + "&sd=" + sd + "&ed=" + ed, header).subscribe(
      response => {
        let data = new StationAvailabilities( < Availabilitie[] > ( < BasicResponse > response).data, 0, station.id, station.latitude, station.longitude, station.name, "");
        // console.log("local");
        // console.log(data);

        observer.next([data]);

      }, error => {
        observer.error(null)
        observer.complete()
      });

    //            this.GetALLStations(0,token, observer);
    if (checkAround) this.http.get(this.publicUrl + "api/v2/stations/" + station.id + "/around_availabilities?startdate=" + departure + "&enddate=" + arrival + "&sd=" + sd + "&ed=" + ed, header).subscribe(
      response => {
        // console.log("around");
        // console.log( < StationAvailabilities[] > ( < BasicResponse > response).data);
        observer.next( < StationAvailabilities[] > ( < BasicResponse > response).data)
        observer.complete();

      }, error => {
        observer.error(null)
        observer.complete()
      });
  }

  public getStationAvailabilitiesGuest(station: Station, departure: string, arrival: string, checkAround: boolean = true, observer: Subscriber < StationAvailabilities[] > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
        .set('Content-Type', 'application/x-www-form-urlencoded')
    }
    this.http.get(this.publicUrl + "api/v2/guest/books/availability?stationid=" + station.id + "&startdate=" + departure + "&enddate=" + arrival, header).subscribe(
      response => {
        let data = new StationAvailabilities( < Availabilitie[] > ( < BasicResponse > response).data, 0, station.id, station.latitude, station.longitude, station.name, "");
        // console.log("local");
        // console.log(data);

        observer.next([data]);

      }, error => {
        observer.error(null)
        observer.complete()
      });

    //            this.GetALLStations(0,token, observer);
  }




  public getStationAvailabilitiesWithGPS(type: string, longitude: number, latitude: number , departure: string, arrival: string, sd: any, ed: any) : Observable<any> {

    
    let tokenString = localStorage.getItem('token_clem_mobi')
    let token =  JSON.parse(tokenString)  

        let httpOptions = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' +token.access_token)}

    return this.http.get<any>(this.publicUrl + "api/v2/stations_geoloc_around_availabilities?" + type + "&startdate=" + departure + "&enddate=" + arrival + "&longitude=" + longitude  + "&latitude=" + latitude + "&sd=" + sd + "&ed=" + ed, httpOptions)
      
}




public getStationAvailble(station: Station, departure: string, arrival: string, sd: any, ed: any) : Observable<any> {

    
  let tokenString = localStorage.getItem('token_clem_mobi')
  let token =  JSON.parse(tokenString)  

      let httpOptions = {
        headers: new HttpHeaders()
          .set('Authorization', 'Bearer ' +token.access_token)}

  return this.http.get<any>(this.publicUrl + "api/v2/stations/" + station.id + "/availabilities?startdate=" + departure + "&enddate=" + arrival + "&sd=" + sd + "&ed=" + ed, httpOptions)
    
}








  public getStationAvailabilities(station: Station, departure: string, arrival: string,sd :any,ed: any, checkAround: boolean = true) {

    return new Observable < StationAvailabilities[] > ((observer) => {
      this.autorizationService.login(null).subscribe(reponse => {
        let token = < Token > reponse;

        if (token == null) {
          observer.error(null)
          observer.complete()
        }
        // console.log(sd)
        // console.log(ed)
        this.userService.getCurrentUserData().subscribe(
          response => {
            this.getStationAvailabilitiesAuth(station, departure, arrival, sd, ed, checkAround, observer, token);
          },
          error => {
            this.getStationAvailabilitiesGuest(station, departure, arrival, checkAround, observer, token);
          }
        )
      });
    });
  }


  
  private getStationPriceGuest(stationId: number, duration: number, startdate: string, observer: Subscriber < StationPrice > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }

    //            this.GetALLStations(0,token, observer);
    this.http.get(this.publicUrl + "api/v2/guest/station_details/" + stationId + "/price?duration=" + duration + "&startdate=" + startdate, header).subscribe(
      response => {
        // console.log( < StationDetail > ( < BasicResponse > response).data);
        observer.next( < StationPrice > ( < BasicResponse > response).data);
        observer.complete()

      }, error => {
        observer.next(null);
        observer.complete()
      });
  }

  private getStationPriceAuth(stationId: number, duration: number, startdate: string, observer: Subscriber < StationPrice > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }

    //            this.GetALLStations(0,token, observer);
    this.http.get(this.publicUrl + "api/v2/station_details/" + stationId + "/price?duration=" + duration + "&startdate=" + startdate, header).subscribe(
      response => {
        // console.log( < StationDetail > ( < BasicResponse > response).data);
        observer.next( < StationPrice > ( < BasicResponse > response).data);
        observer.complete()

      }, error => {
        observer.next(null);
        observer.complete()
      });
  }

  public stationGetPrice(stationId: number, duration: number, startdate: any) {




    var date_start =  startdate.getFullYear() + "-" +
    ("0" + (startdate.getMonth()+1)).slice(-2) + "-" +
    ("0" + startdate.getDate()).slice(-2) + "T" +
    ("0" + startdate.getHours()).slice(-2) + ":" +
    ("0" + startdate.getMinutes()).slice(-2) + ":" +
    ("0" + startdate.getSeconds()).slice(-2)+"Z";



    return new Observable < StationPrice > ((observer) => {
      if (stationId == undefined) {
        observer.next(null)
        observer.complete();
      } else {
        this.autorizationService.login(null).subscribe(reponse => {
          let token = < Token > reponse;

          if (token == null) {
            observer.error(null)
            observer.complete()
          }
          this.userService.getCurrentUserData().subscribe(
            response => {
              this.getStationPriceAuth(stationId, duration, date_start, observer, token);
            },
            error => {
              this.getStationPriceGuest(stationId, duration, date_start, observer, token);
            }
          )
        });
      }
    });
  }

  private getStationDetailFromIdAuth(stationId: number, observer: Subscriber < StationDetail > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }
    this.http.get(this.publicUrl + "api/v2/station_details/" + stationId + "?language=fr", header).subscribe(
      response => {
        // console.log( < StationDetail > ( < BasicResponse > response).data);
        observer.next( < StationDetail > ( < BasicResponse > response).data);
        observer.complete()

      }, error => {
        observer.next(null);
        observer.complete()
      });
  }

  private getStationDetailFromIdGuest(stationId: number, observer: Subscriber < StationDetail > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }
    this.http.get(this.publicUrl + "api/v2/guest/station_details/" + stationId, header).subscribe(
      response => {
        // console.log( < StationDetail > ( < BasicResponse > response).data);
        observer.next( < StationDetail > ( < BasicResponse > response).data);
        observer.complete()

      }, error => {
        observer.next(null);
        observer.complete()
      });
  }

  public getStationDetailFromId(stationId: number) {
    return new Observable < StationDetail > ((observer) => {


      if (stationId == undefined) {
        observer.next(null)
        observer.complete();
      } else {
        this.autorizationService.login(null).subscribe(reponse => {
          let token = < Token > reponse;

          if (token == null) {
            observer.next(null)
            observer.complete()
          }
          this.userService.getCurrentUserData().subscribe(
            response => {
              this.getStationDetailFromIdAuth(stationId, observer, token);
            },
            error => {
              this.getStationDetailFromIdGuest(stationId, observer, token);
            }
          )
        });
      }
    });
  }

  private getStationDetailAuth(station: Station, observer: Subscriber < Station > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }
    this.http.get(this.publicUrl + "api/v2/station_details/" + station.id, header).subscribe(
      response => {
        // console.log( < StationDetail > ( < BasicResponse > response).data)
        station.detail = < StationDetail > ( < BasicResponse > response).data;
        observer.next(station)
        observer.complete()

      }, error => {
        observer.next(null);
        observer.complete()
      });
  }

  private getStationDetailGuest(station: Station, observer: Subscriber < Station > , token: Token) {
    var header = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + token.access_token)
    }
    this.http.get(this.publicUrl + "api/v2/guest/station_details/" + station.id, header).subscribe(
      response => {
        // console.log( < StationDetail > ( < BasicResponse > response).data)
        station.detail = < StationDetail > ( < BasicResponse > response).data;
        observer.next(station)
        observer.complete()

      }, error => {
        observer.next(null);
        observer.complete()
      });
  }

  public getStationDetail(station: Station) {
    return new Observable < Station > ((observer) => {
      if (station == undefined) {
        observer.next(null)
        observer.complete();
      } else {
        this.autorizationService.login(null).subscribe(reponse => {
          let token = < Token > reponse;

          if (token == null) {
            observer.next(null)
            observer.complete()
          }
          this.userService.getCurrentUserData().subscribe(
            response => {
              this.getStationDetailAuth(station, observer, token);
            },
            error => {
              this.getStationDetailGuest(station, observer, token);
            }
          )
        });
      }
    });
  }


    // get  Communautes
    getCommunautes(): Observable<any> {

      let tokenString =  localStorage.getItem('token_offline')
      let token =  JSON.parse(tokenString)  
     
             let httpOptions = {
               headers: new HttpHeaders()
                 .set('Authorization', 'Bearer ' +token.access_token)}
                 
       return this.http.get<any>(`${this.publicUrl}/api/v2/guest/communautes?display_to_inform_page=true`, httpOptions);
     }



  constructor(private cookieService: CookieService,private autorizationService: AutorizationService, private http: HttpClient, private publicService: PublicService, private userService: UserApiService) {}
}
